import { css } from "@emotion/react";

import theme from "../../styles/theme";
import { greyF7, black1D } from "../../styles/variables";

const { spacing } = theme;

export const root = css`
  background-color: ${greyF7};
  box-shadow: none;
  border-radius: 4px;
  margin-bottom: ${spacing(1)}px;

  &::before {
    background-color: transparent;
  }

  &.Mui-expanded {
    margin: ${spacing(1, 0)};
  }
`;

export const expandIcon = css`
  color: ${black1D};
`;

export const header = css`
  font-weight: bold;
  font-size: 14px;
`;

export const details = css`
  display: flex;
  flex-direction: column;
`;
